<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import PVEtudeEcoForm from "./PVEtudeEcoForm.vue"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            dialogTitle: "Étude économique PV",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = withDefaults(
    defineProps<{
        /** Identifiant Mongo du dimensionnement PV (_id) pour lequel créer l’étude éco. */
        dimensionnementId?: string | null
        /** Segment tarifaire du compteur (ex. C5). */
        segment?: string
    }>(),
    {
        dimensionnementId: null,
        segment: "C5",
    }
)

const emit = defineEmits<{
    done: [analyse: Record<string, unknown>]
}>()

const visible = defineModel<boolean>("visible", { default: false })

// ================================
// DONNÉES CALCULÉES
// ================================
const getCanShowForm = computed(
    () =>
        visible.value &&
        typeof props.dimensionnementId === "string" &&
        props.dimensionnementId.length > 0
)

// ================================
// INTERACTIONS
// ================================
function onFormQuit(): void {
    visible.value = false
}

function onFormDone(analyse: Record<string, unknown>): void {
    visible.value = false
    emit("done", analyse)
}
</script>

<template>
    <BaseDialog
        :visible="visible"
        modal
        dismissable-mask
        :header="t('dialogTitle')"
        class="w-full max-w-5xl"
        :pt="{
            content: { class: 'max-h-[min(85vh,48rem)] overflow-y-auto' },
        }"
        @update:visible="visible = $event"
    >
        <PVEtudeEcoForm
            v-if="getCanShowForm"
            :dimensionnement-id="dimensionnementId!"
            :segment="segment"
            @quit="onFormQuit"
            @done="onFormDone"
        />
    </BaseDialog>
</template>
